<h2 mat-dialog-title>Migrate Group</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <p>
    This action can migrate whole website group to a new server. All sites under this main domain
    will be moved to the new server.
  </p>
  <form [formGroup]="form">
    <app-input-field
      label="Move to a new server"
      placeholder="Select server"
      type="autocomplete"
      formControlName="server"
      [options]="(servers$ | async) || []"
      [(searchText)]="serverSearchText"
      [errorMessages]="{
        required: 'Server is required',
        forbiddenServer: 'The selected server must be different from the current server',
      }"
    ></app-input-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">
    Start Group Migration
  </button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
